module.exports = __webpack_public_path__ + "static/media/_print.180172cd.svg";